import React, { useState } from 'react';
import { userShape, historyShape } from 'constants/propTypes';
import { useQuery } from '@apollo/client';
import { withRouter } from 'react-router';
import { GET_SHIFT_REPORTS } from 'store/queries';
import { withUser } from 'components/queries/GetUserQuery';
import { today } from 'utils/dates';
import { parse } from 'query-string';
import { pipe, head, propOr, pathOr } from 'ramda';
import AgentPortalError from 'errors/AgentPortalError';
import { ACTION_CODES } from 'constants/errors';
import Shifts from './Shifts';

const Index = ({
  user,
  history: {
    location: { search }
  }
}) => {
  const { startDate: startDateInput = null, endDate: endDateInput = null, shouldUseByPeriod } = parse(search);
  const startDate = startDateInput || today();
  const endDate = endDateInput || today();

  const [userDetails, setUserDetails] = useState({
    username: user.username,
    officeCode: pipe(propOr([], 'offices'), head, propOr('', 'name'))(user)
  });

  const { loading, data, error } = useQuery(GET_SHIFT_REPORTS, {
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    variables: {
      username: userDetails.username,
      officeCode: userDetails.officeCode,
      organizationCode: pathOr('', ['organization', 'code'], user),
      startDate,
      endDate,
      shouldUseByPeriod: Boolean(shouldUseByPeriod)
    }
  });

  if (error) {
    throw new AgentPortalError(error, ACTION_CODES.REDIRECT_TO_CUSTOM_PAGE, {
      errorCTARedirect: '/shifts'
    });
  }

  return (
    <Shifts
      user={user}
      startDate={startDate}
      shiftReports={data ? data.getCombinedShiftReport : {}}
      loading={loading}
      username={userDetails.username}
      officeCode={userDetails.officeCode}
      setUserDetails={setUserDetails}
    />
  );
};

Index.propTypes = {
  user: userShape,
  history: historyShape
};

export default withRouter(withUser(Index));
